var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import axios from 'axios';
import { getCookie } from '../_utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { authHeader as _authHeader, refreshToken } from './index';
import * as amplitude from '@amplitude/analytics-browser';
import { setAmplitudeUserId as _setAmplitudeUserId, useIsMobile as _useIsMobile, useLockScroll as _useLockScroll, useQueryStringParams as _useQueryStringParams, } from '../hooks';
import { validateBirth as _validateBirth, validateCode as _validateCode, validateEmail as _validateEmail, validateName as _validateName, validatePassword as _validatePassword, validatePhoneNumberWithCountryCode as _validatePhoneNumberWithCountryCode, } from '../';
var apiUrl = (_a = process.env.REACT_APP_ONLINE_API_URL) !== null && _a !== void 0 ? _a : process.env.NEXT_PUBLIC_ONLINE_API_URL;
export var authHeader = _authHeader;
export var fetchIsLoggedIn = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, url, response, e_1, newToken, retryResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getCookie('token');
                if (!token) {
                    return [2, { noToken: true }];
                }
                url = "".concat(apiUrl, "/v1/auth/verify");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 8]);
                return [4, axios.get(url, {
                        withCredentials: true,
                        headers: _authHeader(),
                    })];
            case 2:
                response = _a.sent();
                return [2, response.data];
            case 3:
                e_1 = _a.sent();
                if (!(e_1.response.status === 401 || e_1.response.status === 422)) return [3, 6];
                return [4, refreshToken()];
            case 4:
                newToken = _a.sent();
                return [4, axios.get(url, {
                        withCredentials: true,
                        headers: _authHeader(),
                    })];
            case 5:
                retryResponse = _a.sent();
                return [2, retryResponse.data];
            case 6:
                console.error(e_1);
                throw e_1;
            case 7: return [3, 8];
            case 8: return [2];
        }
    });
}); };
export var useFetchIsLoggedIn = function () {
    var _a;
    var query = useQuery({
        queryKey: ['isLoggedIn'],
        queryFn: function () {
            return fetchIsLoggedIn();
        },
        staleTime: 0,
        gcTime: 0,
    });
    var isSuccess = query.isSuccess && !((_a = query.data) === null || _a === void 0 ? void 0 : _a.noToken);
    return __assign(__assign({}, query), { isSuccess: isSuccess });
};
export var useUpdateIsLoggedIn = function (isLoginProcessShow) {
    var queryClient = useQueryClient();
    useEffect(function () {
        queryClient.invalidateQueries({
            queryKey: [['isLoggedIn']],
        });
    }, [isLoginProcessShow]);
};
export var setAmplitudeUserId = function (user_id) {
    _setAmplitudeUserId(user_id);
};
export var getAmplitudeInstance = function () {
    return amplitude;
};
export var useIsMobile = _useIsMobile;
export var useLockScroll = _useLockScroll;
export var useQueryStringParams = _useQueryStringParams;
export var validateEmail = _validateEmail;
export var validatePassword = _validatePassword;
export var validateName = _validateName;
export var validateCode = _validateCode;
export var validatePhoneNumberWithCountryCode = _validatePhoneNumberWithCountryCode;
export var validateBirth = _validateBirth;
//# sourceMappingURL=exports.js.map